import { environment } from 'environments/environment';

export type EnvType = 'Sandbox' | 'Inc' | 'Bermuda';

export function getEnvType(): EnvType {
  if (!environment.production) {
    return 'Sandbox';
  }

  return environment.isBermuda ? 'Bermuda' : 'Inc';
}
